import { InfoCircle } from 'assets/icons/InfoCircle';

import './styles.scss';

export const DisclaimerCard = () => {
  return (
    <div className="disclaimer-card">
      <div className="card-header">
        <InfoCircle />
        <p className="label">Lưu ý</p>
      </div>
      <div className="card-content">
        <p>
          Chúng tôi đã nỗ lực và cẩn trọng để hoàn thiện tài liệu này. Tuy nhiên
          tài liệu chỉ dùng với mục đích tham khảo. Hình ảnh, sơ đồ kỹ thuật, bố
          trí nội thất hay thông tin mô tả chỉ nhằm mục đích minh họa, không
          phải là thông tin hiện thực hay cam kết pháp lý. Thông tin chính thức
          căn cứ trên Hợp đồng mua bán. Tên căn hộ và ký hiệu căn hộ cho mục
          đích giới thiệu, tên căn hộ và ký hiệu căn hộ chính thức sẽ được ghi
          nhận tại Hợp đồng mua bán.
        </p>
        <br />
        <p>
          <p className="label">Ghi chú</p>
          <p>
            Diện tích sử dụng căn hộ sau cùng sẽ được xác minh bởi đơn vị đo đạc
          </p>
        </p>
      </div>
    </div>
  );
};
